var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVixyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005568;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M133.2,326.4l55.2,173.6h2.1l55.3-173.6h53.5l-78.7,228.4h-62.2L79.6,326.4H133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M363.9,326.4v228.4h-48.3V326.4H363.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M437.7,326.4l46.1,77.9h1.8l46.3-77.9h54.5l-69.7,114.2l71.3,114.2h-55.5l-46.8-78h-1.8l-46.8,78h-55.3 l71.5-114.2l-70.2-114.2H437.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M592.1,326.4h54.1l52.1,98.4h2.2l52.1-98.4h54.1l-83.3,147.7v80.8h-48v-80.8L592.1,326.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVixyIcon);
export default __webpack_public_path__ + "static/media/vixy_icon.e93d51aedc53c5fef64f78701f5a9ab6.svg";
export { ForwardRef as ReactComponent };